import React from 'react';
import IComponent from '../../../../services/forms.interface';
import CheckIcon from '@mui/icons-material/Check';
import ToggleButton from '@mui/material/ToggleButton';
import makeStyles from '@mui/styles/makeStyles';
import createStyles from '@mui/styles/createStyles';
import { Theme } from '@mui/material/styles';
import classNames from 'classnames';
import { FormControl, Typography } from '@mui/material';
import myxss from './myxss';

const useStyles = makeStyles((theme: Theme) =>
    createStyles({
        toggle: {
            backgroundColor: '#F9F9F9',
            outlineColor: 'rgba(0, 0, 0, 0.23)',
            outlineWidth: '1px',
            outlineStyle: 'solid',
            margin: '1px',
            '&.MuiToggleButton-root.Mui-selected': {
                backgroundColor: theme.palette.primary.main,
                color: theme.palette.primary.contrastText,
            },
            '&.error': {
                color: theme.palette.error.main,
                outlineColor: theme.palette.error.main,
            }
        },
        formControl: {
            display: 'flex',
            flexDirection: 'row',
            flexWrap: 'nowrap',
            justifyContent: 'space-between',
            marginRight: '5px',
            flexBasis: '98%',
        },
        mobile: {
        },
        label: {
            marginRight: '20px',
            marginTop: '10px',
        }
    }),
);

interface IButtonProps extends Omit<IComponent, 'defaultValue'> {
    defaultValue: boolean;
}

const Hipaa: React.FC<IButtonProps> = props => {
    const [selected, setSelected] = React.useState(false);
    const classes = useStyles();

    const handleChange = (event) => {
        const newValue = !selected ? 'true' : 'false';
        props.handleChange(event, props.id, newValue);
        setSelected(!selected);
    };

    let baseClasses = 'item SortableItem rfb-item';
    if (props.editMode) { baseClasses += ' is-editing'; }
    if (!props.editMode) { baseClasses += ' not-is-editing'; }
    if (props.selected) { baseClasses += ' selected'; }

    return (
        <div className={baseClasses}>
            <FormControl className={`${classes.formControl} ${props.isMobile ? classes.mobile : ''}`}>
                <div className={classes.label}>
                    <Typography variant="subtitle1" fontSize={17}>
                        {myxss.process(props.label)}
                    </Typography>
                </div>
                <ToggleButton
                    value="check"
                    selected={selected}
                    onChange={handleChange}
                    className={classNames(classes.toggle, { error: props.hasOwnProperty('error') })}
                    size="small"
                >
                    <CheckIcon />
                </ToggleButton>
            </FormControl>
        </div>
    );
}

export default Hipaa;